export const SELECTOR_SHOW  = 'SELECTOR_SHOW';
export const SELECTOR_HIDE  = 'SELECTOR_HIDE';